import React, { useState } from 'react';
import Modal from './Modal';
import { BiSearch, BiPlus } from 'react-icons/bi';
import { memberData, servicesData, medicineData } from '../Datas';
import { RadioGroup } from '@headlessui/react';
import { Button } from '../Form';

function PatientMedicineServiceModal({ closeModal, isOpen, patient, onSelectItem }) {
  const [selected, setSelected] = useState(memberData[0]);
  const [modalOpen, setModalOpen] = useState(isOpen); // State variable to control the visibility of the modal
  const datas = patient
    ? memberData
    : [...servicesData.slice(1, 100), ...medicineData].sort((a, b) =>
        a.name > b.name ? 1 : -1
      );

  // Function to handle item selection and pass the item name to the parent
  const handleSelectItem = (itemName) => {
    onSelectItem(itemName);
    setModalOpen(false); // Close the PatientMedicineServiceModal after item selection
  };

  // Function to handle item click and prevent modal closing
  const handleClick = (event, itemName) => {
    event.stopPropagation(); // Prevent event propagation to the modal close function
    handleSelectItem(itemName); // Handle item selection
  };
  // Function to handle modal close
  const handleCloseModal = () => {
    setModalOpen(false);
    closeModal(); // Close the modal
  };

  return (
    <Modal
      closeModal={handleCloseModal} // Use handleCloseModal to control modal close
      isOpen={modalOpen} // Use modalOpen state variable to control modal visibility
      title={patient ? 'Patients' : 'Medicine & Services'}
      width={'max-w-xl'}
    >
      <div className="flex-colo gap-6">
        {/* search */}
        <div className="flex items-center gap-4 w-full border border-border rounded-lg p-3">
          <input type="text" placeholder="Search" className="w-full" />
          <BiSearch className=" text-xl" />
        </div>
        {/* data */}
        <div className="w-full h-[500px] overflow-y-scroll">
          <RadioGroup value={selected} onChange={setSelected}>
            <div className="space-y-2">
              {datas.map((user) => (
                <RadioGroup.Option
                  key={user.id}
                  value={user}
                  className={({ active, checked }) =>
                    `
                    ${active ? 'border-subMain bg-subMain text-white' : ''}
                    rounded-xl border-[1px] border-border p-4 group hover:bg-subMain hover:text-white`
                  }
                  onClick={(e) => handleClick(e, user.name)} // Call handleClick with the event and the item's name
                >
                  {({ active, checked }) => (
                    <>
                      <h6 className="text-sm">
                        {patient ? user.title : user.name}
                      </h6>
                      {patient && (
                        <p
                          className={`${
                            active && 'text-white'
                          } text-xs group-hover:text-white text-textGray mt-1`}
                        >
                          {user.email}
                        </p>
                      )}
                    </>
                  )}
                </RadioGroup.Option>
              ))}
            </div>
          </RadioGroup>
        </div>
        {/* button */}
        <Button onClick={handleCloseModal} label="Add" Icon={BiPlus} />
      </div>
    </Modal>
  );
}

export default PatientMedicineServiceModal;
